/** Helpers for the Contact panel's email edit (spec 2026-10-02-admin-email-change). */
export type EmailConflict = {
  id: number
  name: string | null
  member_account_number: string | null
  titles: string[]
}

/** The 409 body is `{detail: {message, conflicts}}` for a duplicate address,
    `{detail: string}` for everything else. */
export function conflictsFrom(body: unknown): EmailConflict[] {
  const detail = (body as { detail?: unknown } | null)?.detail
  if (detail && typeof detail === 'object' && Array.isArray((detail as { conflicts?: unknown }).conflicts)) {
    return (detail as { conflicts: EmailConflict[] }).conflicts
  }
  return []
}

const STATE: Record<string, string> = {
  sent: 'notice sent',
  held: 'notice held (not yet allowed on this site; resend from the Emails Log)',
  failed: 'notice failed (see the Emails Log)',
  suppressed: 'not sent (address suppressed)',
}

export function noticeSummary(n: { old: string; new: string }): string {
  const old = n.old === 'skipped' ? 'no notice (there was none)' : (STATE[n.old] ?? n.old)
  const neu = n.new === 'skipped' ? 'no notice' : (STATE[n.new] ?? n.new)
  return `Old address: ${old}. New address: ${neu}.`
}
